import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/accounting/vat/$declarationId',
}).lazy(() => import('./vat.$declarationId.index.lazy').then((d) => d.Route))
